import React from 'react';
import { Box, Typography, ClassNameMap } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LoadableTypography } from '@uplift/ui-v2';


export const useStyles = makeStyles<{ disabled?: boolean }>()((theme, props) => ({
  value: {
    display: 'inline-block',
    fontWeight: 700,
    color: props.disabled ? theme.palette.text.disabled : theme.palette.grey[900],
  },
  subtitle: {
    color: theme.palette.grey[500],
  },
}));


export type PeriodSummaryCardBasicProps = {
  value: React.ReactNode;
  title: string;
  range: string;
  classes?: ClassNameMap<'value' | 'subtitle'>;
  disabled?: boolean;
};


export const PeriodSummaryCardBasic: React.FC<PeriodSummaryCardBasicProps> = ({ value, title, range, ...props }) => {
  const { classes } = useStyles(props, { props });
  const isLoading = value === undefined;

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" height="14px">
        <Typography variant="overline">{title}</Typography>
        <LoadableTypography loading={isLoading} width="65px" variant="subtitle2" color="textSecondary">
          {range}
        </LoadableTypography>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center" mt={3} mb={1}>
        <LoadableTypography
          loading={isLoading}
          width="80px"
          component="span"
          variant="h3"
          className={classes.value}
        >
          {value}
        </LoadableTypography>
        <Typography className={classes.subtitle}>
          payout amount
        </Typography>
      </Box>
    </Box>
  );
};
